import api from "../../utils/api"
import { IEmailReport } from "./components/DialogSendMailReport";


export const getReports = async (params?: any, pageNumber?: number, pageSize?: number): Promise<any> => {
    const { data } = await api.get('/report', {
        params: {
            ...params,
            pageNumber,
            pageSize,
            
        }
    });

  return data
}

export const blockReport = async (reportId: number): Promise<void> => {
  await api.put(`/report/block/${reportId}`)
}

export const unblockReport = async (reportId: number): Promise<void> => {
    await api.put(`/report/unblock/${reportId}`)
}

export const getReportPDFBase64 = async (reportId: string, visualizationType: number): Promise<any> => {
  const { data } = await api.get(`/report/${reportId}/pdf`, {
      params: {
          visualizationType,
      }
  })

  return data
}

export const getHistoryReport = async (reportId: string, solicitacaoLis: string): Promise<any> => {
    const historyReport = await api.get(`/report/${reportId}/historic`)
  return historyReport.data
}

export const sendReportEmail = async (data: IEmailReport): Promise<any> => {
    return await api.post(`report/send-email`, data)
}

export const getZipByLote = async (params?: any): Promise<string> => {
  const response = await api.get(`/report/getZipByLote`, {
      params: {
          ...params,
      }
  });
  return response.data;
};

export const generatePdf = async (params?: any): Promise<string> => {
    const response = await api.post("/report/generate", params);
    return response.data.jobId;
};

export const getPdfStatus = async (jobId: string) => {
    const response = await api.get(`/report/status/${jobId}`);
    return response.data;
};

export const downloadPdfZip = async (jobId: string): Promise<Blob> => {
    const response = await api.get(`/report/download/${jobId}`, {
        responseType: "blob",
    });

    return response.data;
};